import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopFetichesNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Datafolha & Omens explicam a vida sexual dos brasileiros | Pesquisa Datafolha e Omens"
        links={[
          {
            to: '/fetiches-e-praticas-no-sexo/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="12" width="12" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/pesquisa-fetiches-e-praticas-no-sexo/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="12" width="12" />
                <span>Ver a pesquisa completa</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopFetichesNavigation
